export enum DebugMode {
    None = "None",
    Log = "Log",
    Debug = "Debug",
}
